import React, { useEffect } from 'react';
import { UnlockPanelManager } from '@multiversx/sdk-dapp/out/managers/UnlockPanelManager';
import { useNavigate } from 'react-router-dom';
import { AuthRedirectWrapper } from 'components';
import { routeNames } from 'routes';

const UnlockPage = () => {
  const navigate = useNavigate();

  const unlockPanelManager = UnlockPanelManager.init({
    loginHandler: () => {
      navigate(routeNames.faucet);
    },
    onClose: async () => {
      navigate(routeNames.home);
    }
  });

  useEffect(() => {
    unlockPanelManager.openUnlockPanel();
  }, []);

  return null;
};

export const Unlock = () => (
  <AuthRedirectWrapper>
    <UnlockPage />
  </AuthRedirectWrapper>
);
